import React from 'react'
import { Property } from 'csstype'
import styled from 'styled-components'

/*
This icon was obtained from font awesome:
Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc.
 */

const StyledSvgWrapper = styled.div<{ $width: string; $height: string }>`
  width: ${({ $width }) => $width};
  height: ${({ $width }) => $width};
`

export const LinkedIn: React.FC<{ size: string; color: Property.Color }> = ({
  size,
  color,
}) => {
  return (
    <StyledSvgWrapper $width={size} $height={size}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 25 25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.52737 20.625H4.02875V9.35843H7.52737V20.625ZM5.77618 7.82156C4.65743 7.82156 3.75 6.89492 3.75 5.77618C3.75 5.2388 3.96347 4.72343 4.34345 4.34345C4.72343 3.96347 5.2388 3.75 5.77618 3.75C6.31355 3.75 6.82892 3.96347 7.2089 4.34345C7.58888 4.72343 7.80235 5.2388 7.80235 5.77618C7.80235 6.89492 6.89455 7.82156 5.77618 7.82156ZM20.6216 20.625H17.1305V15.1405C17.1305 13.8334 17.1041 12.1572 15.3115 12.1572C13.4925 12.1572 13.2138 13.5773 13.2138 15.0463V20.625H9.71891V9.35843H13.0744V10.8953H13.1234C13.5905 10.0101 14.7314 9.07591 16.4337 9.07591C19.9745 9.07591 20.6254 11.4076 20.6254 14.4361V20.625H20.6216Z"
          fill={color}
        />
      </svg>
    </StyledSvgWrapper>
  )
}
